import SiteLayout from "@/components/layouts/SiteLayout";
import FacebookAuthService from "@/server/services/auth/FacebookAuthService";
import UserService from "@/server/services/user/UserService";
import CommonUtils from "@/utils/CommonUtils";
import { useRouter } from "next/router";
import { useState } from "react";
import { FaGoogle } from "react-icons/fa";
import { LuInstagram } from "react-icons/lu";

export async function getServerSideProps(context) {
  const loginLink = FacebookAuthService.getInstagramLoginURL();

  try {
    const user = await UserService.getLoggedInUser(context.req, {
      whatsapp_number: true,
      phone: true,
      thumbnail_path: true,
    });
    if (user) {
      return {
        redirect: {
          destination: `/${CommonUtils.getLocaleFromContext(
            context
          )}agent-admin/account/business-profile`,
          permanent: false,
        },
      };
    }
  } catch (ignore) {}

  return { props: { loginLink } };
}

export default function SignIn({ loginLink }) {
  //check if there is error parameter in the url
  const [clickDisabled, setClickDisabled] = useState(false);
  const [instaClickDisabled, setInstagramClickDisabled] = useState(false);
  const router = useRouter();
  const error = router.query.error;
  let error_message = "";

  switch (error) {
    case "token":
      error_message = "Could not complete login, please try again";
      break;
    case "not-finished":
      error_message = "Login process was not completed, please try again";
      break;
    case "account":
      error_message = "Could not retrieve account details, please try again";
      break;
    case "permissions":
      error_message = "Could not get account permissions, please try again";
      break;
    default:
      error_message = "";
      break;
  }

  const connect = () => {
    setInstagramClickDisabled(true);
    window.location.href = loginLink;
  };
  const signInWithGoogle = () => {
    setClickDisabled(true);
    router.push("/api/google-auth");
  };

  return (
    <SiteLayout
      title={"Login or Register as agent | " + CommonUtils.appName}
      description="
        Login or Register as agent to start listing your properties on Makazi Mapya
      "
    >
      <div className="container mx-auto space-y-4  text-center mb-[400px] mt-[200px]">
        {error_message && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
            role="alert"
          >
            <strong className="font-bold">Error!</strong>
            <span className="block sm:inline">{error_message}</span>
          </div>
        )}

        <h2 className="text-3xl">Sign in as agent</h2>

        <div className="mt-10 grid place-content-center gap-4">
          <div>
            <button
              disabled={instaClickDisabled}
              onClick={connect}
              className="bg-blue-500 w-full justify-center text-center text-white px-4 py-3 space-x-2 rounded font-bold text-lg flex items-center"
            >
              <LuInstagram className="inline-block " />
              <span>
                {instaClickDisabled ? "Loading..." : "Sign in with Instagram"}
              </span>
            </button>
            <p className="text-gray-600">
              Sign in as agent using your instagram account sync your posts
            </p>
          </div>

          <div>
            <button
              disabled={clickDisabled}
              onClick={signInWithGoogle}
              className="bg-blue-500 w-full justify-center text-center text-white px-4 py-3 space-x-2 rounded font-bold text-lg flex items-center"
            >
              <FaGoogle className="inline-block " />
              <span>
                {clickDisabled ? "Loading..." : "Sign in with Google"}
              </span>
            </button>
          </div>
          <p className="text-gray-800 mt-4">
            By signing in, you agree to our terms of service and privacy policy
          </p>
        </div>
      </div>
    </SiteLayout>
  );
}
